/**
 * Created by sumudu on 12/5/16.
 */
'use strict';

(function () {
    angular
        .module('crewSchedule')
        .service('crewSchAssignTraningLogic', crewSchAssignTraningLogic);

    function crewSchAssignTraningLogic(rx, RemoteService, crewSchAssignTraningModel, MessageService,
                                       applicationConstants, CrewingAdaptor, EventManagerService, CrewingHelper) {
        var self = this;

        var crewInfo = null;
        var lastTrainingRequestParam = null;

        crewSchAssignTraningModel.crewInfo.subscribe(function (info) {
            crewInfo = info;
        });

      self.trainee = [];

        self.loadTrainingsForLastRequest = function () {
            if (!!lastTrainingRequestParam) {
                self.loadTrainingsForCrew(lastTrainingRequestParam.crewDetails, lastTrainingRequestParam.fromDate, lastTrainingRequestParam.toDate);
            }
        };

        /**
         * Get Trainings for Crew
         * @param prams
         */
        self.loadTrainingsForCrew = function (crewDetails, fromDate, toDate) {
            //Reset Trainings
            lastTrainingRequestParam = {
                crewDetails : crewDetails,
                fromDate : fromDate,
                toDate : toDate
            }
            crewSchAssignTraningModel.setTrainingsForCrew([]);

            var request = {
                fromDate: fromDate,
                toDate: toDate,
                crewProfileId:  crewDetails && crewDetails.crewProfileId,
                pageSize: 100,
                startPosition: 1
            };

            var blocksForDay = CrewingHelper.getBlocksForCrew(crewDetails && crewDetails.crewId, fromDate,toDate);

            var getAssignedTraining = function (slotId) {
                var selected = false;
                if (!!blocksForDay) {
                    for (var i = 0; i < blocksForDay.length; i++) {
                        var events;
                        var found;
                        if(blocksForDay[i].eventType == 'PATTERN'){
                            events = blocksForDay[i].events;
                            found =  _.find(events,{trainingSlotId : slotId});
                            if(!!found){
                                selected = found;
                            }
                        }
                    }
                }
                return selected;
            };

            rx.Observable.fromPromise(RemoteService.searchTrainingProgramAssignedTrainingSlots(request))
                .map(function (response) {
                    return rx.Observable.from(response.trainingProgramsAssignedSlots || []);
                })
                .flatMap(function (observer) {
                    return observer.groupBy(function (training) {
                        return training.trainingProCategory;
                    }).flatMap(function (group) {
                        return group.reduce(function (acc, curr) {
                            (!!acc[curr.trainingProCategory]) ? acc[curr.trainingProCategory].push(curr) : acc[curr.trainingProCategory] = [curr]
                            return acc;
                        }, {});
                    })
                })
                .map(function (trainingGroup) {
                    var cat = Object.keys(trainingGroup)[0];
                    return {
                        category: cat,
                        trainings: trainingGroup[cat].map(function (training) {
                            training.dayString = moment(training.startDateZulu, applicationConstants.SETTINGS.DATE_FORMAT).format('Do');
                            training.monthString = moment(training.startDateZulu, applicationConstants.SETTINGS.DATE_FORMAT).format('MMMM');
                            var allreadyAssigned = getAssignedTraining(training.trainingSlotId)
                            training.isAssigned = !!allreadyAssigned;
                            training.crewScheduleBlockId = allreadyAssigned.crewScheduleBlockId || null;
                            return training
                        })
                    }
                })
                .reduce(function (adapted, data, index) {
                    data.id = index;
                    adapted.push(data);
                    return adapted;
                }, [])
                .subscribe(
                    function (groupedTraining) {
                        crewSchAssignTraningModel.setTrainingsForCrew(groupedTraining);
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                );
        };

        /**
         * Assign Training logic
         * @param training
         */
        self.assignTraining = function (training) {
            var flags = {
                isContinueIllegal: true,
                isUserConfirm: false,
                isExpiryUpdatable: false,
                isIgnoreConflicts: false,
                isIgnoreExpiries: false,
                isIgnoreParentHubDeletedConflict: false
            };

            var trainingData = {};
            trainingData.crewProfileId = crewInfo.crewProfileId;
            trainingData.trainingSlotId = training.trainingSlotId;
            trainingData.trainingSlotProgramId = training.trainingSlotProramId || null;
            trainingData.trainingProgramId = training.trainingProgramId;
            trainingData.trainingProgDetailId = training.trainingProgramDetailId;
            trainingData.assignDate = training.startDateZulu;
            trainingData.assignTime = training.startTimeZulu;
            trainingData.courseId = null;
            trainingData.courseTxnId = null;

            var onAssignSuccess = function () {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.REFRESH);
            };

            var onCancel = function () {
                training.isAssigned = false;
            };

            var doAssign = function (params, flag) {
                params.continueIllegal = !!flags.isContinueIllegal;
                params.userConfirm = !!flags.isUserConfirm;
                params.expiryUpdatable = !!flags.isExpiryUpdatable;
                params.ignoreConflicts = !!flags.isIgnoreConflicts;
                params.ignoreExpiries = !!flags.isIgnoreExpiries;
                params.ignoreParentHubDeletedConflict = !!flags.isIgnoreParentHubDeletedConflict;

                RemoteService.assignTraining(params).then(
                    function (response) {
                        var adapted = CrewingAdaptor.assignTrainingAdaptor(response);
                        CrewingHelper.assignTrainingActionList(params, adapted, flag, doAssign, onAssignSuccess, onCancel);
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                );
            };

            doAssign(trainingData, flags);
        };

        /**
         * Unassign Training logic
         */
        self.unAssignTraining = function (training) {
            var params = {
                unAssignColl : [
                    {
                        crewProfileId: crewInfo.crewProfileId,
                        crewSchdBlockId: training.crewScheduleBlockId
                    }
                ]
            };

            RemoteService.unAssignBlock(params).then(
                function (response) {
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.REFRESH);
                        MessageService.success(MessageService.MESSAGES.CREWING.DUTY_REMOVE_SUCCESS);
                },
                function (error) {
                    training.isAssigned = true;
                    MessageService.error(MessageService.MESSAGES.CREWING.DUTY_REMOVE_FAILED);
                }
            );
        };


    }
})();
